import ENV from "config/Env";
import { backendQueryKey } from "hooks";

export type WebhookHistory = {
  tabletkey: number;
  sentContent: string;
  responseStatus: number;
  responseContent: string;
  sentDate: string;
};

export type WebhookHistoryResponse = {
  history: WebhookHistory[];
};

const component = "AcsesLogsDashboard";

export const AcsesDashboardQueryKeys = {
  list: backendQueryKey<WebhookHistoryResponse>({ component, baseUrl: ENV.acsesBaseURL, endpoint: "/events/history" })
};
